// @flow
import moment from "moment"

import { cuckooEvents } from "common/consts/enums"
import { HAS_LOCAL_STORAGE, setItem, getItem } from "common/browser/utils/localStorage"

const UTM_LIST = [
  "utm_source",
  "utm_medium",
  "utm_term",
  "utm_content",
  "utm_campaign",
  "mkt_route",
  "mkt_postback",
  "mkt_origin",
  "mkt_form",
  "mkt_agency",
]

type UtmSet = {
  utm_source?: string,
  utm_medium?: string,
  utm_term?: string,
  utm_content?: string,
  utm_campaign?: string,
  mkt_route?: string,
  mkt_postback?: string,
  mkt_origin?: string,
  mkt_form?: string,
  mkt_agency?: string,
}

export const isFresh = (item: { value: string, createdAt: Date }): boolean => {
  const date = new Date(item.createdAt)
  return moment()
    .subtract(1, "months")
    .isBefore(date)
}

// eslint-disable-next-line flowtype/no-weak-types
export function loadFromSession(cuckoo: Object): UtmSet {
  if (HAS_LOCAL_STORAGE) {
    return UTM_LIST.reduce((acc, key) => {
      try {
        const rawItem = getItem(key)
        if (rawItem) {
          const item = JSON.parse(rawItem)
          if (item && isFresh(item)) {
            return {
              ...acc,
              [key]: item.value,
            }
          }
        }
      } catch (e) {
        cuckoo.error(cuckooEvents.GENERAL_ERROR_UTM_LOCAL_STORAGE_LOAD, { error: String(e) })
      }
      return acc
    }, {})
  }
  return {}
}

// eslint-disable-next-line flowtype/no-weak-types
export function saveToSession(cuckoo: Object, object: UtmSet): void {
  if (HAS_LOCAL_STORAGE) {
    Object.keys(object)
      .filter(key => UTM_LIST.includes(key))
      .forEach(key => {
        try {
          setItem(key, JSON.stringify({ value: object[key], createdAt: new Date() }))
        } catch (e) {
          cuckoo.error(cuckooEvents.GENERAL_ERROR_UTM_LOCAL_STORAGE_SET, { error: String(e) })
        }
      })
  }
}
